import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { BudgetType } from '../types';

export function useFormattedDays() {
  const intl = useIntl();

  return useCallback(
    (days: number, output: BudgetType) => {
      if (output === 'weekly') {
        const decimal = +(days / 7).toFixed(2); // 2 decimals
        const weeks = Math.floor(days / 7);
        const remainingDays = days % 7;

        return intl.formatMessage(
          {
            defaultMessage: '{decimal} weeks ({weeks}W {days}D)',
          },
          {
            decimal,
            weeks,
            days: remainingDays,
          },
        );
      }

      if (output === 'monthly') {
        const decimal = +(days / 30).toFixed(2); // 2 decimals
        const months = Math.floor(days / 30);
        const remainingDays = days % 30;

        return intl.formatMessage(
          {
            defaultMessage: '{decimal} months ({months}M {days}D)',
          },
          {
            decimal,
            months,
            days: remainingDays,
          },
        );
      }

      return intl.formatMessage({ defaultMessage: '{days} days' }, { days });
    },
    [intl],
  );
}
